import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect:'index/home'
    // name: 'home',
    // component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/index',
    name: 'index',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/index.vue'),
    children:[
      {
        path: '/index/home',
        name: 'home',
        component: () => import(/* webpackChunkName: "about" */ '../views/home.vue'),
        meta:{iocn:  require('../assets/业务数字平台/平台架构.png')}
      },
      {
        path: '/index/business',
        name: 'business',
        component: () => import(/* webpackChunkName: "about" */ '../views/business.vue'),
        meta:{iocn:  require('../assets/业务数字平台/业务布局.png')}
      },
      {
        path: '/index/config',
        name: 'config',
        component: () => import(/* webpackChunkName: "about" */ '../views/config.vue'),
        meta:{iocn:  require('../assets/业务数字平台/配置.png')}
      },
    ]
    },
 
]

const router = new VueRouter({
  // mode: 'history',
  base: '/dist',
  routes
})

export default router
